
// LegalResourceCard.js
//
// A clickable card pointing to a specific legal document (Privacy Policy,
// Terms of Use, ...). Used on the /legal hub page.

import React from 'react';
import { useNavigate } from 'react-router-dom';

import TitleField from '../text/TitleField';
import TextField from '../text/TextField';

import '../../styles/legalcomponents/LegalResourceCard.css';

const LegalResourceCard = ({ icon: Icon, title, description, ctaText, to }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (to) navigate(to);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className="legal-resource-card"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
        >
            {Icon &&
                <div className="legal-resource-card-icon-container">
                    <Icon className="legal-resource-card-icon"/>
                </div>
            }

            <div className="legal-resource-card-text-container">
                <TitleField title={title} bold={true} fontSize="1.35rem"/>
                <TextField text={description} fontColor="#555555" fontSize="0.95rem"/>
            </div>

            <span className="legal-resource-card-cta">{ctaText} &rarr;</span>
        </div>
    );
};

export default LegalResourceCard;
